/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyDashboardIcon = createIcon("EmptyDashboardIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: ".35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#A5AEFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54 44 18 18v26.007c0 .548-.455.993-1 .993H37c-.552 0-1-.446-1-.993V62l18-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 42 23.793 23.793a.993.993 0 010 1.413l-.087.088a1.006 1.006 0 01-1.42-.008L74 65v23.846a2 2 0 01-1.852 1.995l-.15.005H35.916a1.99 1.99 0 01-1.995-1.996l.076-23.847-2.284 2.283a1.001 1.001 0 01-1.42.008l-.087-.088a1 1 0 010-1.413L54 42Zm0 3L36 62.999v25.008c0 .508.386.929.884.986L37 89h34c.545 0 1-.445 1-.993V63L54 45Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m60 39 18 18v24.997C78 82.55 77.545 83 77 83H43c-.552 0-1-.451-1-1.003V57l18-18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m60 36 23.793 23.793a.993.993 0 010 1.413l-.087.088a1.006 1.006 0 01-1.42-.008L80 59v23.846a2 2 0 01-1.852 1.995l-.15.005H41.916a1.99 1.99 0 01-1.995-1.996l.076-23.847-2.283 2.283a1.001 1.001 0 01-1.42.008l-.088-.088a1 1 0 010-1.413L60 36Zm0 3L42 56.999v25.008c0 .508.386.929.884.986L43 83h34c.545 0 1-.445 1-.993V57L60 39Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 83H54v-9.005c0-.55.547-.995 1.194-.995H64.8c.665 0 1.2.456 1.2.995V83Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 83v-8.005C64 75 55.995 75 55.995 75 56 75 56 83 56 83h8Z",
    fill: "#A5AEFF"
  }));
}, {
  "i18nKey": "svg.EmptyDashboardIcon"
});